import {
  SearchParamsPetCounts,
  SearchParamsPetType,
} from '@rover/constants/src/translations/sitterProfilePage.constants';
import { useApiBrightHorizonsSitterProfileBannerRetrieve } from '@rover/rsdk/src/apiClient/latest/api-bright-horizons-sitter-profile-banner-retrieve';
import type { BrightHorizonsSitterProfileBanner } from '@rover/rsdk/src/apiClient/latest/model/brightHorizonsSitterProfileBanner';

import { getSitterSlugFromWebUrl } from '../components/RevampServicesCta/utils';

import { useRevampCta } from './useRevampCta';

type RevampBrightHorizonsBanner = {
  brightHorizonsBanner?: BrightHorizonsSitterProfileBanner;
  /**
   * Whether the banner carries a message to render. The price transparency banner
   * stands down for it, the way it does in the other CTA layouts.
   */
  isShowingBhBanner: boolean;
};

/**
 * The Bright Horizons eligibility banner for the service and pets currently
 * selected. It is only fetched for a flagged user, so everyone else reads it as
 * absent.
 */
export const useRevampBrightHorizonsBanner = (
  petType: SearchParamsPetType,
  petCount: SearchParamsPetCounts
): RevampBrightHorizonsBanner => {
  const { sitterData, serviceType, isBrightHorizonsUser } = useRevampCta();

  const { data: brightHorizonsBanner } = useApiBrightHorizonsSitterProfileBannerRetrieve(
    {
      serviceType: serviceType || 'boarding',
      slug: getSitterSlugFromWebUrl(sitterData.webUrl),
      petType: petType || SearchParamsPetType.DOG_CAT,
      dogCount: petCount.selectedDogCount,
      catCount: petCount.selectedCatCount,
      puppyCount: petCount.selectedPuppyCount,
    },
    { query: { enabled: isBrightHorizonsUser } }
  );

  return {
    brightHorizonsBanner,
    isShowingBhBanner: !!brightHorizonsBanner?.bannerMessage,
  };
};

export default useRevampBrightHorizonsBanner;
